module.exports={ORDER_REPORTS:"Order reports",BUILD_REPORT:"Create report"};